// extracted by mini-css-extract-plugin
module.exports = {"menu":"_1UHuH-cNRJ8kzwt1fgimp0","menuItem":"XkR_zOwfHwjYbXv0U7FiB"};